import { useState, useContext } from "react";
import Stepper from "./Stepper";
import Account from "./Account";
import DriversLicense from "./DriversLicense";
import Agreements from "./Agreement";
import DataContext from "../../context/data-context";
import poshBkg from "../../assets/img/posh-bg.webp";
import Business from "./Business";
import { UtilityContext } from "../../context/util-context";

export default function Setup() {
  const { fetchData } = useContext(DataContext);
  const { navigate } = useContext(UtilityContext);
  const [progress, setProgress] = useState(0);

  const completeSetup = () => {
    navigate("/general");
    fetchData();
  };

  return (
    <div className="flex justify-center p-4 md:items-center">
      <img
        className="fixed top-0 left-0 object-cover w-screen h-screen -z-10"
        src={poshBkg}
      />
      <div className="p-8 md:p-16 bg max-w-[800px]">
        <div className="mb-4">
          <Stepper progress={progress} steps={4} stepHandler={setProgress} />
        </div>
        {progress === 0 && <Account setProgress={setProgress} />}
        {progress === 1 && <Business setProgress={setProgress} />}
        {progress === 2 && <DriversLicense setProgress={setProgress} />}
        {progress === 3 && <Agreements completeSetup={completeSetup} />}
      </div>
    </div>
  );
}
